import {Heading, Text, Box, Center, Card, CardHeader, CardBody} from "@chakra-ui/react"
import { Helmet } from 'react-helmet';

export default function HowToCreateAnImpactfulStyle() {
    return (
    <>
    <Helmet>
      <title>Ką rengtis pagal Viliją Rušinskaitę - Kaip susikurti poveikį darantį stilių</title>
      <meta name="description" content="Kaip susikurti poveikį darantį stilių" />
      <meta property="og:title" content="Kaip susikurti poveikį darantį stilių" />
      <meta property="og:description" content="Kaip susikurti poveikį darantį stilių"/>
      <meta property="og:image" content="https://karengtis.lt/vilija1_small.jpg" />
      <meta property="og:url" content="https://www.karengtis.lt/apie" />
    </Helmet>
    <Box minH='2vw' />
    <Center>
    <Card border='1px' maxWidth="80vw" minWidth='60vw' shadow='none'>
      <CardHeader >
        <Box minH='1vw' />
        <Center>
          <Heading as='h1' sx={{ fontSize: '32px', fontFamily: 'Montserrat, sans-serif' }}>Kaip susikurti poveikį darantį stilių</Heading>
        </Center>
      </CardHeader>
    <Center>
    <CardBody pt='0'>
        <Box>
        <Text pt='2' fontSize='xl'>
          Iš kokių esminių elementų susideda ne tik akiai maloni apsirengimo visuma, bet ir į savo pusę
galintis palenkti, geresnes sąlygas leidžiantis išsiderėti įvairiuose scenarijuose ir autoritetą bei
įtaką padedantis susikurti asmeninis stilius?
          </Text>
          <Box minH='1vw' />
          <Text pt='2' fontSize='xl' display='inline' fontWeight="bold">
          Išgryninti esminiai elementai </Text><Text  fontSize='xl' display='inline'> 
           ir nereikalingų, dėmesį blaškančių detalių atsisakymas. Pavyzdžiui,
jeigu vadovaujate įmonei, kolektyvui ar dideliems procesams, rinkitės aiškią ir tvirtą struktūrą
turinčius drabužius, daugiau švarkų, minimalistiškesnę estetiką ir atsirinkit tik jums tinkančias
spalvas. Minimalizuokit smulkių raštų, pastelinių spalvų ir plaukiančių lininių komplektų vilkėjimą
darban.
          </Text>
          <Box minH='1vw' />
          <Text pt='2' fontSize='xl' display='inline' fontWeight="bold">
          Intencijos turėjimas </Text><Text  fontSize='xl' display='inline'> 
          bent jau sau, apie ją nebūtina pasakoti niekam kitam. Ta intencija gali būti
perkalibruojama kiekvienam svarbiam susitikimui pagal jo tikslą ir siekį. Kiekvienam renginiui,
kuriame jūs kalbate, dalyvaujate ar kurį moderuojat. Visada jaučiasi, kas atėjo apsirengęs be
intencijos. Tai jaučiasi ir užsičiuopia panašiai kaip matant skirtumą tarp gatve be konkretaus tikslo
vaikštinėjančių turistų ir su tikslu kažkur normaliu tempu žingsniuojančių vietinių.
          </Text>
          <Box minH='1vw' />
          <Text pt='2' fontSize='xl' display='inline' fontWeight="bold">
          Signature braižas. </Text><Text  fontSize='xl' display='inline'> 
          Savo estetinės krypties žinojimas padeda nesiblaškyti ir ramiai judėti ten, kur
jums reikia. Atsakykit į klausimą kokie 3 žodžiai geriausiai nusako jūsų stilių ir rengiantis bei
apsiperkant atkris daugybė jums neaktualių dalykų. Jeigu nesugalvojat šių žodžių tada susirašykit
3 mados ženklus, kurie labiausiai atitinka jūsų estetiką.
          </Text>
          <Box minH='1vw' />
          <Text pt='2' fontSize='xl' display='inline' fontWeight="bold">
          Taikli šukuosena/kirpimas ir sąmoningas sprendimas apie savo plaukus. </Text><Text  fontSize='xl' display='inline'> 
          Kokia ta šukuosena
turėtų būti jums padėti atsakyti galiu aš arba jūsų plaukų stilistas. Tik iškart pasakysiu, kad jokia
šukuosena po kirpimo savaime kasdien neatrodys kaip iš paveikslėlio. Ranką ir plaukų priemonę
pridėti tikrai teks, tiesiog priimkit tai kaip neišvengiamą gyvenimo dalį arba išvis kaip žaidimą.
          </Text>
          <Box minH='1vw' />
          <Text pt='2' fontSize='xl' display='inline' fontWeight="bold">
          Kokybė prieš kiekybę, </Text><Text  fontSize='xl' display='inline'> 
          net apsiperkant greitosios mados parduotuvėse. Pasidomėkite audiniais,
kokybiškomis sudėtimis, ko tikėtis iš kurio audinio ir ko niekada nesitikėti. Pavyzdžiui, neturėkite
iliuzijų, kad viskozinė suknelė nesiglamžys ir turi šansų atrodyti reprezentatyviai prisėdus. Tikrai
neturi, viskozė visada klaikiai glamžosi. Sijoną ar suknelę vasaros darbinei aplinkai geriau rinkitės
plonos vilnos, džinso arba poliesterio, o palaidines, liemenes ir švarkus galite rinktis jau vien
natūralius ir plonus, bet nepermatomus. Tinka ir šilkas, ir medvilnė, ir linas, ir viskozė.
Banguotų ar kreivų siūlių pastebėjimas, reiklumas klešnių ir rankovių ilgiui, pečių linijos taiklumui
bei pačių drabužių tvarkai, švarai ir pasirūpinimas preciziška jų būkle irgi turėtų būti normalia
kasdienės rutinos dalimi norint kilstelėti savo galimybių kartelę aukščiau.
          </Text>
          <Box minH='1vw' />
          <Text pt='2' fontSize='xl' display='inline' fontWeight="bold">
          Savo ūgio ir kūno proporcijų supratimas. </Text><Text  fontSize='xl' display='inline'> 
          Tam padeda aplinkos stebėjimas ir bandymas
įsivardinti, kodėl viena ar kita proporcija derinyje veikia arba ne. Žinoma, yra ir figūrų tipų
almanachai, jie niekada neklaidina apie proporcijų ABC. Idealu, jeigu tai taptų automatiniu įpročiu
- "pasimatuoti" proporcijas ir galėti jas numatyti.
          </Text>
          <Box minH='1vw' />
          <Text pt='2' fontSize='xl' display='inline' fontWeight="bold">
          Elegantiškumo ir puošnumo adekvatus kiekis. </Text><Text  fontSize='xl' display='inline'> 
          Jo negali visai nebūti įtakingo žmogaus stiliuje.
O be to taip juk maloniau - dailiai apsirengti, apsiauti ir susišukuoti. Nepaisant koks jūsų darbas,
kelias ir tikslas šiame gyvenime. Neužsihipnotizuokime kasdieniškumo ir praktiškumo banalume.
O nežodiniai pasirinkimai yra ne mažiau svarbi komunikacijos priemonė. Jeigu renkatės nieko apie
save nesakyti savo stiliumi arba nuolatiniu kedų ir skinny džinsų vilkėjimu byloti "nesukit man
galvos ir netrukdykit man būti patogiai" - tai irgi yra iškalbinga.
          </Text>
          <Box minH='1vw' />
          <Text pt='2' fontSize='xl' display='inline' fontWeight="bold">
          Kažkas asmeniškai simboliško. </Text><Text  fontSize='xl' display='inline'> 
          Šis elementas yra svarbiausias. Jis žymi, kad save tikrai gerai
pažįstate ne tik paviršiniu "patinka" ir "nepatinka" lygmeniu. Jūs jau atsakėt sau ir apie
priežastinius savo pasirinkimų ryšius bei leidžiat sau pasirinkti elementus, kurie jus pastiprina ir
pakelia motyvaciją tik dėl jums žinomų priežasčių. O tai yra neįkainojama ir nenuperkama stiliaus
dalis. Tikrasis įtakingo stiliaus voodoo.
          </Text>
          <Box minH='1vw' />
        </Box>
    </CardBody>
    </Center>
    </Card>
    </Center>
    <Box minH='2vw' />
    </>
    )
  }